import React, { useContext }  from 'react';
import { Spacer, Text } from 'react-onei';

import UserContext from '../../../context/UserContext';
import { EMAIL_TYPE, MOBILE_TYPE } from '../../../helpers/account';

const LiveboxContacts = ({ otcContacts, liveboxContacts }) => {
    const { wording } = useContext(UserContext);
    const { WLOST_280, WLOST_282, WLOST_283, WLOST_284, WLOST_285, WLOST_286, WLOST_287 } = wording;

    const getLiveboxWording = () => {
        const liveboxMobile = liveboxContacts.find(contact => contact.contactType === MOBILE_TYPE);
        const liveboxEmail = liveboxContacts.find(contact => contact.contactType === EMAIL_TYPE);
        const hasOtcContacts = otcContacts.length > 0;

        let text;

        if (liveboxMobile && liveboxEmail) {
            text = hasOtcContacts ? WLOST_287 : WLOST_284;
            text = text.replace('{mobile}', liveboxMobile.contactView);
            text = text.replace('{email}', liveboxEmail.contactView);
        } else if (liveboxMobile) {
            text = hasOtcContacts ? WLOST_283 : WLOST_286;
            text = text.replace('{mobile}', liveboxMobile.contactView);
        } else if (liveboxEmail) {
            text = hasOtcContacts ? WLOST_282 : WLOST_285;
            text = text.replace('{email}', liveboxEmail.contactView);
        }

        return <div dangerouslySetInnerHTML={{ __html: text }}></div>
    }

    return (
        <div className="spacing-xs">
            <Text variant="lead" id="livebox-title">
                <strong>
                    {WLOST_280}
                </strong>
            </Text>
            <Text id="livebox-text">
                {getLiveboxWording()}
            </Text>
            <Spacer color="grey4" className="spacing-xs" />
        </div>
    )
}

LiveboxContacts.defaultProps = {
    liveboxContacts: [],
    otcContacts: []
};

export default LiveboxContacts;